/** Build the `## MCP servers` system-prompt section: an inventory of the
 *  currently connected servers, plus a guidance block per declaration that
 *  carries preset custom instructions (the materialized MCP.md body). Returns
 *  "" when there is neither an inventory nor any guidance. */
export function buildMcpPromptSection(
  declarations: { id: string; instructions?: string }[],
  connected?: { id: string; toolCount: number }[],
): string {
  const withGuidance = declarations.filter(
    (d): d is { id: string; instructions: string } =>
      !!d.instructions && d.instructions.trim().length > 0,
  );
  const inventory = connected ?? [];
  if (withGuidance.length === 0 && inventory.length === 0) return "";
  const lines: string[] = ["## MCP servers", ""];
  if (inventory.length > 0) {
    const listed = inventory
      .map((s) => `\`${s.id}\` (${s.toolCount} tool${s.toolCount === 1 ? "" : "s"})`)
      .join(", ");
    lines.push(`Connected: ${listed}. Call their tools as \`mcp__<server>__<tool>\`.`);
    lines.push("");
  }
  for (const d of withGuidance) {
    lines.push(`Guidance for \`${d.id}\`:`);
    lines.push(d.instructions.trim());
    lines.push("");
  }
  return lines.join("\n").trimEnd();
}
